// extracted by mini-css-extract-plugin
module.exports = {"pagelayout-bd":"PageLayout_pagelayout-bd__fd12s"};